module.exports = __webpack_public_path__ + "static/media/header-banner.ddcdab99.png";